import { render, staticRenderFns } from "./section-inicio.vue?vue&type=template&id=5519e189&scoped=true"
import script from "./section-inicio.vue?vue&type=script&lang=js"
export * from "./section-inicio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5519e189",
  null
  
)

export default component.exports